import { Loader } from '@googlemaps/js-api-loader';
import { COOKIE_TYPE, EVENT_ACCEPTED_COOKIES_CHANGED, getAcceptedCookies, } from './cookies';
const loader = new Loader({
    apiKey: process.env.GOOGLE_MAPS_API_KEY,
});
const mapOptions = {
    center: { lat: 50, lng: 11 },
    zoom: 5,
    maxZoom: 18,
};
async function renderMap() {
    const mapContainer = document.querySelector('.map');
    const mapData = JSON.parse(document.getElementById('facility-data')?.innerText ?? '');
    if (!mapContainer) {
        return null;
    }
    try {
        await loader.load();
    }
    catch (e) {
        console.error(`Failed to load google api: ${e}`);
        return;
    }
    const map = new google.maps.Map(mapContainer, mapOptions);
    let minLat = 180;
    let maxLat = 0;
    let minLng = 180;
    let maxLng = 0;
    mapData.facilities.forEach(el => {
        const locationLat = parseFloat(el.position.lat);
        const locationLng = parseFloat(el.position.lng);
        if (minLat > locationLat) {
            minLat = locationLat;
        }
        if (maxLat < locationLat) {
            maxLat = locationLat;
        }
        if (minLng > locationLng) {
            minLng = locationLng;
        }
        if (maxLng < locationLng) {
            maxLng = locationLng;
        }
        const marker = new google.maps.Marker({
            position: {
                lat: locationLat,
                lng: locationLng,
            },
            map,
            title: el.name,
            icon: {
                path: 'M71 35.4169C71 54.95 51.7426 75.2504 41.5947 84.5919C38.1068 87.8027 32.8932 87.8027 29.4053 84.5919C19.2574 75.2504 0 54.95 0 35.4169C0 15.8567 15.8939 0 35.5 0C55.1061 0 71 15.8567 71 35.4169ZM35.5 49.9522C43.5464 49.9522 50.0694 43.4445 50.0694 35.4169C50.0694 27.3893 43.5464 20.8817 35.5 20.8817C27.4536 20.8817 20.9306 27.3893 20.9306 35.4169C20.9306 43.4445 27.4536 49.9522 35.5 49.9522Z',
                fillColor: '#E3021C',
                fillOpacity: 1,
                scale: 0.5,
                anchor: new google.maps.Point(35, 87),
            },
        });
        let infoContent = `
          <b>${el.name}</b>
          <br/>
          ${el.address}
          <br/>`;
        if (mapData.showDetailsLink) {
            infoContent += `
          <a class="link" href="${el.link}">
            <span>Details</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 12L20.25 12" stroke="#37517A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.5 18.75L20.25 12L13.5 5.25" stroke="#37517A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>`;
        }
        const infowindow = new google.maps.InfoWindow({
            content: `<div class="info-window">${infoContent}</div>`,
        });
        marker.addListener('click', () => {
            infowindow.open({
                anchor: marker,
                map,
                shouldFocus: false,
            });
        });
    });
    map.fitBounds({ north: maxLat, east: maxLng, south: minLat, west: minLng }, 32);
}
function activateGoogleMaps(acceptedCookies) {
    if (acceptedCookies && acceptedCookies.includes(COOKIE_TYPE.GOOGLE_MAPS)) {
        renderMap();
    }
}
window.addEventListener('DOMContentLoaded', () => {
    const acceptedCookies = getAcceptedCookies();
    activateGoogleMaps(acceptedCookies);
});
window.addEventListener(EVENT_ACCEPTED_COOKIES_CHANGED, e => {
    activateGoogleMaps(e.detail.acceptedCookies);
});
